// Module
var code = "<div> <a ui-sref=\"group.alarms(vm.linkParams)\" ng-if=\"vm.alarm>0\"> <i class=\"fa fa-fw\" ng-class=\"{'info':vm.alarm===1,'warning':vm.alarm===2,'error':vm.alarm===3,'fa-bell':vm.alarm>0}\" title=\"{{(vm.alarm===1?'Information':(vm.alarm===2?'Warning':'Critical'))|translate}}\"></i> </a> </div>";
// Exports
module.exports = code;